(() => {
  if (window.__bxV2Ready) return;
  window.__bxV2Ready = true;
  const syncShelf = section => {
    const track = section.querySelector('.bxv-product-grid');
    const controls = section.querySelector('[data-bxv-shop-arrows]');
    if (!track || !controls) return;
    const visible = [...track.querySelectorAll('[data-bxv-roles]')].filter(card => !card.hidden).length;
    const overflows = visible > 3 && track.scrollWidth > track.clientWidth + 2;
    controls.hidden = !overflows;
    const max = track.scrollWidth - track.clientWidth;
    controls.querySelector('[data-bxv-shop-prev]').disabled = !overflows || track.scrollLeft < 2;
    controls.querySelector('[data-bxv-shop-next]').disabled = !overflows || track.scrollLeft >= max - 2;
  };
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-bxv-shop-prev], [data-bxv-shop-next]');
    if (arrow) {
      const section = arrow.closest('[data-bxv-shop]');
      const track = section?.querySelector('.bxv-product-grid');
      const first = track?.querySelector('[data-bxv-roles]:not([hidden])');
      if (track && first) {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left:(first.getBoundingClientRect().width + gap) * (arrow.hasAttribute('data-bxv-shop-next') ? 1 : -1),behavior:'smooth'});
      }
      return;
    }
    const button = event.target.closest('[data-bxv-filter]');
    if (!button) return;
    const section = button.closest('[data-bxv-shop]');
    if (!section) return;
    const value = button.dataset.bxvFilter;
    section.querySelectorAll('[data-bxv-filter]').forEach(chip => {
      const active = chip === button;
      chip.classList.toggle('is-active', active);
      chip.setAttribute('aria-pressed', String(active));
    });
    section.querySelectorAll('[data-bxv-roles]').forEach(card => {
      const roles = (card.dataset.bxvRoles || '').split('|').map(role => role.trim());
      card.hidden = value !== 'all' && !roles.includes(value);
      card.querySelectorAll('[data-bxv-role]').forEach(label => { label.hidden = value !== 'all' && label.dataset.bxvRole !== value; });
    });
    section.querySelector('.bxv-product-grid')?.scrollTo({left:0,behavior:'instant'});
    requestAnimationFrame(() => syncShelf(section));
  });
  document.querySelectorAll('[data-bxv-shop]').forEach(section => {
    const track = section.querySelector('.bxv-product-grid');
    track?.addEventListener('scroll', () => syncShelf(section), {passive:true});
    new ResizeObserver(() => syncShelf(section)).observe(track);
    syncShelf(section);
    const products = [...section.querySelectorAll('[data-bxv-use]')].map(card => ({item_name:card.dataset.title,item_list_name:'Homepage – Shop'}));
    if (products.length) window.dataLayer?.push({event:'view_item_list',ecommerce:{item_list_name:'Homepage – Shop',items:products}});
  });
})();
